"use client";
import {
  Button,
  Card,
  Checkbox,
  Input,
  Typography,
} from "@rahul8864/material-ui";

import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/Form";

import { zodResolver } from "@hookform/resolvers/zod";
import Link from "next/link";
import { useState } from "react";
import { useForm } from "react-hook-form";

import { signIn } from "next-auth/react";
import { useRouter } from "next/navigation";
import { useCallback } from "react";
import { toast } from "sonner";
import { type LoginFormValues, loginSchema } from "@/schemas/Users";

const defaultValues = {
  email: "",
};

const ForgotPassword: React.FC = () => {
  const router = useRouter();
  const [loading, setLoading] = useState<boolean>(false);

  const form = useForm<LoginFormValues>({
    resolver: zodResolver(loginSchema),
    defaultValues,
  });

  const handleSubmit = useCallback(
    async (data: LoginFormValues) => {
      try {
        setLoading(true);
        await signIn("credentials", { ...data, redirect: false }).then(
          (callback) => {
            if (callback?.error) {
              setLoading(false);
              toast.error(callback.error);
            } else if (callback?.ok && !callback?.error) {
              toast.success("Logged in Successfully!");
              router.push("/");
              setLoading(false);
            }
          },
        );
      } catch (e) {
        setLoading(false);
        toast.error("Something went wrong!");
      } finally {
      }
    },
    [router],
  );

  return (
    <div className="mx-auto w-full max-w-7xl p-8">
      <div className="relative flex items-center justify-center p-8">
        <Card color="transparent" className="border p-6">
          <Typography variant="h4" color="blue-gray" className="pb-4">
            Forgot your Password?
          </Typography>
          <Form {...form}>
            <form
              className="mb-2 w-80 max-w-screen-lg border-t pt-4 sm:w-96"
              onSubmit={form.handleSubmit(handleSubmit)}
            >
              <div className="mb-1 flex flex-col gap-6">
                <FormField
                  control={form.control}
                  name="email"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>
                        Email <span className="text-red-500">*</span>
                      </FormLabel>
                      <FormControl>
                        <Input
                          size="lg"
                          className="!border-t-blue-gray-200 placeholder:opacity-100 focus:!border-t-gray-900"
                          labelProps={{
                            className: "hidden",
                          }}
                          disabled={loading}
                          placeholder="devmobile@shop.in"
                          {...field}
                        />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
              </div>
              <Button
                className="mt-4 justify-center normal-case"
                fullWidth
                type="submit"
                size="lg"
                loading={loading}
                disabled={loading}
              >
                Reset Password
              </Button>
              <Typography color="gray" className="mt-4 text-center font-normal">
                {"Remember your Password? "}
                <Link href="/sign-in" className="font-medium text-gray-900">
                  Sign In
                </Link>
              </Typography>
            </form>
          </Form>
        </Card>
      </div>
    </div>
  );
};

export default ForgotPassword;
